import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio-four-column',
  templateUrl: './portfolio-four-column.component.html',
  styleUrls: ['./portfolio-four-column.component.scss']
})
export class PortfolioFourColumnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
